// AppKitProvider.jsx
import React from "react";
import { createAppKit } from '@reown/appkit/react'
import { WagmiProvider } from 'wagmi'
import { 
  mainnet,
  aurora,
  arbitrum,
  avalanche,
  base,
  bsc,
  fantom,
  gnosis,
  klaytn,
  optimism,
  polygon
} from '@reown/appkit/networks'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'

// 0. Setup queryClient
const queryClient = new QueryClient()

// 1. Get projectId from https://cloud.reown.com
const projectId = '551825c80d19ed9a4ab4ee09c77de434'

// 2. Create a metadata object - optional
const metadata = {
  name: 'CoinHeatMap',
  description: 'AppKit Example',
  url: 'https://www.coinheatmap.com', // origin must match your domain & subdomain
  icons: ['https://assets.reown.com/reown-profile-pic.png']
}

// 3. Set the networks
const networks = [
  mainnet,
  aurora,
  arbitrum,
  avalanche,
  base,
  bsc,
  fantom,
  gnosis,
  klaytn,
  optimism,
  polygon
]

// 4. Create Wagmi Adapter
export const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: true
});

// 5. Create modal (this sets up the Reown AppKit context)
createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata,
  features: {
    analytics: true // Optional - defaults to your Cloud configuration
  },
    enableCoinbase: true, // true by default
})


export function AppKitProvider({ children }) {
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </WagmiProvider>
  )
}